/*
 * Module for a list of contents
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/contentsSplit/contents/contentsList/contentsListView",
  "modules/shared/sortableList/sortableListModule",
  "modules/contentsSplit/contents/contentsList/contentsControls/contentsControlsModule",
  "modules/contentsSplit/content/contentPreview/contentPreviewModule",
], function (
  Marionette,
  Messenger,
  ContentsListView,
  SortableListModule,
  ContentsControlsModule,
  ContentPreviewModule,
) {
  var ContentsListController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contentsList";
      this.region = options.region;
      this.group = null; //selected group
      this.rootContentGroup = options.rootContentGroup;
      this._setUpVents();
    },
    show: function (groupModel) {
      this.group = groupModel;
      //if the group is deleted, then null out this reference (needed for the validation not to interfere with switching to the parent group)
      this.group.on(
        "destroy",
        function () {
          this.group = null;
        },
        this,
      );
      var headers = Messenger.reqres.request("contents:headers");
      this.layout = new ContentsListView.contentsListLayout();
      this.controls = this.addSubModule(
        new ContentsControlsModule({ region: this.layout.controls }),
      );
      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          namespace: this.name,
        }),
      );
      this.preview = this.addSubModule(
        new ContentPreviewModule({ region: this.layout.contentPreview }),
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(groupModel);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _showSubViews: function (groupModel) {
      this.controls.show(groupModel, this.rootContentGroup);
      this.list.show(groupModel.contents());
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "contents:select:group",
        function (groupView) {
          if (groupView.model !== this.group) {
            //check if we can close and save any open textboxes and
            //make sure that the current selected group is safe to save (eventually)
            if (Messenger.reqres.request("save:textbox") && (!this.group || this.group.isValid())) {
              console.log("selected content group");
              this.show(groupView.model);
            } else {
              //cannot select group because the current one is invalid
              //need to set the nav tree back to the current group
              this.group.trigger("select");
            }
          }
        },
        this,
      );
      Messenger.vent.on(
        "contents:select:modified",
        function () {
          console.log("requested modified content");
          this.list.show(this.group.modifiedContent());
        },
        this,
      );

      Messenger.vent.on(
        "contents:select:missing",
        function () {
          console.log("requested modified content");
          this.list.show(this.group.missingContent());
        },
        this,
      );

      Messenger.vent.on(
        "contents:select:ignored",
        function () {
          console.log("requested modified content");
          this.list.show(this.group.ignoredContent());
        },
        this,
      );

      Messenger.vent.on(
        "contents:select:standard",
        function () {
          console.log("requested standard content");
          //clear the group contents in case we made changes to the content when looking at missing/modified/ignored content
          this.rootContentGroup.clearContentCollections();
          this.list.show(this.group.contents());
        },
        this,
      );
      //a row was selected in the sortable list
      Messenger.vent.on(
        this.name + ":selected:row",
        function (model) {
          Messenger.save(function (success) {
            if (success) {
              console.log("selected " + model.get("name"));
              Messenger.vent.trigger("show:content", model); //show content page
            }
          }, this);
        },
        this,
      );
    },
  });

  return ContentsListController;
});
